import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsSnowboardNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M11.823.812A2.6 2.6 0 008.2 2.092L7.034 4.837A27.157 27.157 0 014.82 9l-1.606 2.473A2.606 2.606 0 107.8 13.91l1.16-2.729a27.129 27.129 0 012.214-4.162l1.612-2.489a2.606 2.606 0 00-.963-3.718zm.123 3.173l-1.614 2.49a28.277 28.277 0 00-2.294 4.315l-1.16 2.73a1.606 1.606 0 11-2.825-1.5l1.605-2.476a28.094 28.094 0 002.3-4.315l1.164-2.746a1.605 1.605 0 112.824 1.5v.002z"
        fill=""
      />
    </svg>
  )
);
SvgSportsSnowboardNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgSportsSnowboardNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsSnowboardNormalXsmall;
